// import Modal from "@/components/Modal";
// import PdfViewer from "@/components/PdfViewer";
// import SkeletonRow from "@/components/SkeletonRow";
// import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "@/components/ui/tooltip";
// import useDataPendaftaran from "@/hooks/useDataPendaftaran";
// import useSessionStorage from "@/hooks/useSessionStorage";
// import { getListBerkas } from "@/services/getData";
// import { DataBerkas, SysBerkas } from "@/types";
// import { useQuery } from "@tanstack/react-query";
// import {
//   AlertCircle,
//   CheckCircle2,
//   Download,
//   Eye,
//   FileText,
//   Info,
//   Trash2,
//   Upload,
// } from "lucide-react"; // Gunakan Lucide Icons
// import { useState } from "react";
// import Form from "./Form";
// import useScreen from "@/hooks/useScreen";

// export default function UnggahBerkas({
//   idDataPendaftaran,
//   isValidPermanen,
// }: {
//   idDataPendaftaran: string;
//   isValidPermanen: boolean;
// }) {
//   const {isMobile} = useScreen()
//   const [sessionPeriode] = useSessionStorage("sessionPeriode", {
//     id_sys_periode: "",
//   });
//   const { dataPendaftaran } = useDataPendaftaran();
//   const isKIPK = !!dataPendaftaran?.no_kipk;

//   const [showUpload, setShowUpload] = useState(false);
//   const [showDelete, setShowDelete] = useState(false);
//   const [showPdf, setShowPdf] = useState(false);
//   const [selectedRow, setSelectedRow] = useState<SysBerkas | null>(null);
//   const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null);

//   const { data, isPending } = useQuery({
//     queryKey: ["listDataBerkas", sessionPeriode?.id_sys_periode],
//     queryFn: () => getListBerkas(sessionPeriode?.id_sys_periode || ""),
//   });

//   const filteredlistBerkas = data?.listSysBerkas
//     ?.filter(
//       (sysBerkas: SysBerkas) =>
//         sysBerkas.jenis_berkas?.slug_jenis_berkas !== "Surat_Pernyataan",
//     )
//     .sort(
//       (a: SysBerkas, b: SysBerkas) => Number(b.is_wajib) - Number(a.is_wajib),
//     );

//   const listBerkasPenunjangKIPK = data?.listSysBerkas
//     ? data?.listSysBerkas?.filter((sysBerkas: SysBerkas) => {
//         return sysBerkas.jenis_berkas?.is_penunjang_kipk;
//       })
//     : [];

//   return (
//     <div className="space-y-6 animate-in fade-in duration-500">
//       {/* --- HEADER --- */}
//       <div>
//         <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
//           <FileText className="w-6 h-6 text-blue-600 dark:text-blue-400" />
//           Dokumen & Berkas
//         </h1>
//         <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">
//           Lengkapi dokumen pendukung sesuai persyaratan. Dokumen yang diunggah
//           harus jelas dan terbaca.
//         </p>
//       </div>

//       {/* --- ALERTS --- */}
//       <div className="space-y-4">
//         <Alert className="bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800 text-amber-900 dark:text-amber-200">
//           <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
//           <AlertTitle className="font-bold text-amber-800 dark:text-amber-300">
//             Perhatian
//           </AlertTitle>
//           <AlertDescription className="text-sm">
//             Pastikan setiap dokumen sesuai dengan format yang diminta (PDF/JPG)
//             dan ukuran maksimal yang ditentukan.
//           </AlertDescription>
//         </Alert>

//         {isKIPK && (
//           <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg p-4">
//             <div className="flex items-start gap-3">
//               <Info className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-0.5" />
//               <div>
//                 <h3 className="font-bold text-indigo-900 dark:text-indigo-200 text-sm">
//                   Rekomendasi Peserta KIP Kuliah
//                 </h3>
//                 <p className="text-xs text-indigo-700 dark:text-indigo-300 mt-1 mb-2">
//                   Lengkapi berkas penunjang berikut untuk meningkatkan peluang
//                   lolos seleksi KIP-K:
//                 </p>
//                 <div className="flex flex-wrap gap-2">
//                   {listBerkasPenunjangKIPK?.map((sysBerkas: SysBerkas) => (
//                     <Badge
//                       key={sysBerkas.id_sys_berkas}
//                       variant="secondary"
//                       className="bg-white dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800 text-[10px]"
//                     >
//                       {sysBerkas?.keterangan_berkas}
//                     </Badge>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* --- TABLE CONTENT --- */}
//       {isPending ? (
//         <div className="space-y-3">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonRow key={i} />
//           ))}
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
//           <div className="overflow-x-auto w-full">
//             <table className="w-full text-sm text-left">
//               <thead className="text-xs text-slate-500 uppercase bg-slate-50 dark:bg-slate-950 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
//                 <tr>
//                   <th className="px-4 py-3 w-10 text-center">#</th>
//                   <th className="px-4 py-3 min-w-[200px]">Jenis Dokumen</th>
//                   <th className="px-4 py-3 min-w-[150px]">Keterangan</th>
//                   <th className="px-4 py-3 w-32 text-center">Contoh</th>
//                   <th className="px-4 py-3 w-32 text-center">Status</th>
//                   <th className="px-4 py-3 w-40 text-center">Aksi</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
//                 {filteredlistBerkas?.map((row: SysBerkas, index: number) => {
//                   const berkasSiswa: DataBerkas | undefined =
//                     data?.listDataBerkasSiswa.find(
//                       (berkas: DataBerkas) =>
//                         berkas?.id_sys_berkas == String(row.id_sys_berkas),
//                     );
//                   const isUploaded = !!berkasSiswa;

//                   return (
//                     <tr
//                       key={row.id_sys_berkas}
//                       className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
//                     >
//                       <td className="px-4 py-3 text-center text-slate-400 font-mono text-xs">
//                         {index + 1}
//                       </td>

//                       {/* Jenis Dokumen */}
//                       <td className="px-4 py-3">
//                         <div className="font-medium text-slate-900 dark:text-slate-200">
//                           {row.jenis_berkas?.nama_jenis_berkas}
//                         </div>
//                         {row.is_wajib ? (
//                           <Badge variant={"destructive"}>Wajib</Badge>
//                         ) : (
//                           ""
//                         )}
//                       </td>

//                       {/* Keterangan */}
//                       <td className="px-4 py-3 text-slate-500 dark:text-slate-400 text-xs">
//                         {row?.keterangan_berkas || "-"}
//                       </td>

//                       {/* Format Download */}
//                       <td className="px-4 py-3 text-center">
//                         {row.url_template_berkas ? (
//                           <TooltipProvider>
//                             <Tooltip>
//                               <TooltipTrigger asChild>
//                                 <Button
//                                   variant="outline"
//                                   size="sm"
//                                   className="h-7 text-xs border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400"
//                                   onClick={() =>
//                                     window.open(
//                                       `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
//                                       "_blank",
//                                     )
//                                   }
//                                 >
//                                   <Download className="w-3 h-3 mr-1.5" /> Unduh
//                                 </Button>
//                               </TooltipTrigger>
//                               <TooltipContent>
//                                 Unduh template dokumen
//                               </TooltipContent>
//                             </Tooltip>
//                           </TooltipProvider>
//                         ) : (
//                           <span className="text-slate-300 text-xs">-</span>
//                         )}
//                       </td>

//                       {/* Status */}
//                       <td className="px-4 py-3 text-center">
//                         {isUploaded ? (
//                           <div className="inline-flex items-center gap-1 text-nowrap px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
//                             <CheckCircle2 className="w-3 h-3" />
//                             Sudah Diupload
//                           </div>
//                         ) : (
//                           <div className="inline-flex items-center gap-1 text-nowrap px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400 border border-slate-200 dark:border-slate-700">
//                             Belum Diupload
//                           </div>
//                         )}
//                       </td>

//                       {/* Aksi (Grouped) */}
//                       <td className="px-4 py-3">
//                         <div className="flex items-center justify-center gap-2">
//                           {/* Tombol Lihat (Hanya jika uploaded) */}
//                           {isUploaded && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     variant="ghost"
//                                     size="icon"
//                                     className="h-8 w-8 bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400"
//                                     onClick={() => {
//                                       setShowPdf(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa);
//                                     }}
//                                   >
//                                     <Eye className="w-4 h-4" />
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>Lihat Berkas</TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}

//                           {/* Tombol Upload (Hanya jika belum permanen) */}
//                           {!isValidPermanen && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     size={isUploaded ? "icon" : "sm"}
//                                     className={`h-8 ${
//                                       isUploaded
//                                         ? "w-8 bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
//                                         : "px-3 bg-blue-600 hover:bg-blue-700 text-white text-xs"
//                                     }`}
//                                     onClick={() => {
//                                       setShowUpload(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa || null);
//                                     }}
//                                   >
//                                     <Upload className="w-4 h-4" />
//                                     {!isUploaded && (
//                                       <span className="ml-1.5">Upload</span>
//                                     )}
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>
//                                   {isUploaded
//                                     ? "Ganti Berkas"
//                                     : "Upload Berkas"}
//                                 </TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}

//                           {/* Tombol Hapus (Hanya jika uploaded & belum permanen) */}
//                           {!isValidPermanen && isUploaded && (
//                             <TooltipProvider>
//                               <Tooltip>
//                                 <TooltipTrigger asChild>
//                                   <Button
//                                     variant="ghost"
//                                     size="icon"
//                                     className="h-8 w-8 text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
//                                     onClick={() => {
//                                       setShowDelete(true);
//                                       setSelectedRow(row);
//                                       setSelectedBerkas(berkasSiswa);
//                                     }}
//                                   >
//                                     <Trash2 className="w-4 h-4" />
//                                   </Button>
//                                 </TooltipTrigger>
//                                 <TooltipContent>Hapus Berkas</TooltipContent>
//                               </Tooltip>
//                             </TooltipProvider>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* --- MODALS (Tetap Sama) --- */}
//       <Modal
//         show={showUpload}
//         onClose={() => setShowUpload(false)}
//         className="md:w-[30rem]"
//       >
//         <Form
//           method="POST"
//           selectedRow={selectedRow}
//           selectedBerkas={selectedBerkas}
//           closeModal={() => setShowUpload(false)}
//           idDataPendaftaran={idDataPendaftaran}
//         />
//       </Modal>

//       <Modal show={showDelete} onClose={() => setShowDelete(false)}>
//         <Form
//           method="DELETE"
//           selectedBerkas={selectedBerkas}
//           selectedRow={selectedRow}
//           closeModal={() => setShowDelete(false)}
//         />
//       </Modal>

//       {/* <Modal
//         show={showPdf}
//         onClose={() => setShowPdf(false)}
//         className="h-full lg:w-[60vw] w-[95vw]"
//       >
//         <div>
//           <h1 className="mb-3 font-bold">
//             {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
//           </h1>
//           {selectedBerkas?.nomor ? (
//             <div className="mb-3">
//               <span className="py-0.5 px-3 rounded-full bg-primary font-semibold text-white">
//                 Nomor: {selectedBerkas?.nomor}
//               </span>
//             </div>
//           ) : (
//             ""
//           )}
//           <iframe
//             src={`${selectedBerkas?.path_berkas}`}
//             title="Berkas"
//             className="absolute h-full w-full"
//           />
//         </div>
//       </Modal> */}

//       <Modal
//         show={showPdf}
//         onClose={() => {
//           setShowPdf(false);
//           // Optional: clear selected setelah delay animasi
//           setTimeout(() => setSelectedBerkas(null), 300);
//         }}
//         className="lg:w-[60vw] w-[95vw]"
//       >
//         <div className="flex flex-col gap-4 p-2">
//           <div>
//             <h1 className="font-bold text-lg text-slate-900 dark:text-white">
//               {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
//             </h1>
//             {selectedBerkas?.nomor && (
//               <Badge className="mt-2 bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300">
//                 Nomor: {selectedBerkas?.nomor}
//               </Badge>
//             )}
//           </div>

//           {/* Panggil komponen PdfViewer */}
//           {showPdf && selectedBerkas?.path_berkas && (
//             <PdfViewer url={selectedBerkas.path_berkas} />
//           )}
//         </div>
//       </Modal>
//     </div>
//   );
// }

import Modal from "@/components/Modal";
import PdfViewer from "@/components/PdfViewer";
import SkeletonRow from "@/components/SkeletonRow";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import useDataPendaftaran from "@/hooks/useDataPendaftaran";
import useSessionStorage from "@/hooks/useSessionStorage";
import { getListBerkas } from "@/services/getData";
import { DataBerkas, SysBerkas } from "@/types";
import { useQuery } from "@tanstack/react-query";
import {
  AlertCircle,
  CheckCircle2,
  Download,
  Eye,
  FileText,
  Info,
  Trash2,
  Upload,
} from "lucide-react";
import { useState } from "react";
import Form from "./Form";
import useScreen from "@/hooks/useScreen";

export default function UnggahBerkas({
  idDataPendaftaran,
  isValidPermanen,
}: {
  idDataPendaftaran: string;
  isValidPermanen: boolean;
}) {
  const { isMobile } = useScreen();
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });
  const { dataPendaftaran } = useDataPendaftaran();
  const isKIPK = !!dataPendaftaran?.no_kipk;

  const [showUpload, setShowUpload] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [selectedRow, setSelectedRow] = useState<SysBerkas | null>(null);
  const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null);

  const { data, isPending } = useQuery({
    queryKey: ["listDataBerkas", sessionPeriode?.id_sys_periode],
    queryFn: () => getListBerkas(sessionPeriode?.id_sys_periode || ""),
  });

  const filteredlistBerkas = data?.listSysBerkas
    ?.filter(
      (sysBerkas: SysBerkas) =>
        sysBerkas.jenis_berkas?.slug_jenis_berkas !== "Surat_Pernyataan",
    )
    .sort(
      (a: SysBerkas, b: SysBerkas) => Number(b.is_wajib) - Number(a.is_wajib),
    );

  const listBerkasPenunjangKIPK = data?.listSysBerkas
    ? data?.listSysBerkas?.filter((sysBerkas: SysBerkas) => {
        return sysBerkas.jenis_berkas?.is_penunjang_kipk;
      })
    : [];

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* --- HEADER --- */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
          <FileText className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          Dokumen & Berkas
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm mt-1">
          Lengkapi dokumen pendukung sesuai persyaratan. Dokumen yang diunggah
          harus jelas dan terbaca.
        </p>
      </div>

      {/* --- ALERTS --- */}
      <div className="space-y-4">
        <Alert className="bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800 text-amber-900 dark:text-amber-200">
          <AlertCircle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          <AlertTitle className="font-bold text-amber-800 dark:text-amber-300">
            Perhatian
          </AlertTitle>
          <AlertDescription className="text-sm">
            Pastikan setiap dokumen sudah sesuai dengan format yang ditentukan
            (PDF atau JPG), tidak melebihi batas ukuran yang diperbolehkan,
            serta dapat terbaca dengan jelas.
          </AlertDescription>
        </Alert>

        {isKIPK && (
          <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Info className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-0.5" />
              <div>
                <h3 className="font-bold text-indigo-900 dark:text-indigo-200 text-sm">
                  Rekomendasi Peserta KIP Kuliah
                </h3>
                <p className="text-xs text-indigo-700 dark:text-indigo-300 mt-1 mb-2">
                  Lengkapi berkas penunjang berikut untuk meningkatkan peluang
                  lolos seleksi KIP-K:
                </p>
                <div className="flex flex-wrap gap-2">
                  {listBerkasPenunjangKIPK?.map((sysBerkas: SysBerkas) => (
                    <Badge
                      key={sysBerkas.id_sys_berkas}
                      variant="secondary"
                      className="bg-white dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800 text-[10px]"
                    >
                      {sysBerkas?.keterangan_berkas}
                    </Badge>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* --- CONTENT (TABLE FOR DESKTOP, CARDS FOR MOBILE) --- */}
      {isPending ? (
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : isMobile ? (
        // --- MOBILE CARD VIEW ---
        <div className="grid grid-cols-1 gap-4">
          {filteredlistBerkas?.map((row: SysBerkas, index: number) => {
            const berkasSiswa: DataBerkas | undefined =
              data?.listDataBerkasSiswa.find(
                (berkas: DataBerkas) =>
                  berkas?.id_sys_berkas == String(row.id_sys_berkas),
              );
            const isUploaded = !!berkasSiswa;

            return (
              <div
                key={row.id_sys_berkas}
                className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm p-4 flex flex-col space-y-3"
              >
                {/* Header Card: Judul & Badge Wajib/Status */}
                <div className="flex justify-between items-start gap-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-mono text-slate-400">
                        #{index + 1}
                      </span>
                      {row.is_wajib ? (
                        <Badge
                          variant="destructive"
                          className="px-1.5 py-0 text-[10px]"
                        >
                          Wajib
                        </Badge>
                      ) : (
                        <Badge
                          variant="outline"
                          className="px-1.5 py-0 text-[10px]"
                        >
                          Opsional
                        </Badge>
                      )}
                    </div>
                    <h3 className="font-semibold text-slate-900 dark:text-slate-100 text-sm leading-tight">
                      {row.jenis_berkas?.nama_jenis_berkas}
                    </h3>
                  </div>
                  {/* Status Indicator Mobile */}
                  {isUploaded ? (
                    <div className="inline-flex items-center justify-center p-1.5 rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400">
                      <CheckCircle2 className="w-4 h-4" />
                    </div>
                  ) : (
                    <div className="text-[10px] px-2 py-1 rounded-full bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400 font-medium whitespace-nowrap">
                      Belum Diupload
                    </div>
                  )}
                </div>

                {/* Keterangan */}
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {row?.keterangan_berkas || "Tidak ada keterangan tambahan."}
                </p>

                {/* Template Download Mobile */}
                {row.url_template_berkas && (
                  <div>
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full h-8 text-xs justify-start border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400"
                      onClick={() =>
                        window.open(
                          `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
                          "_blank",
                        )
                      }
                    >
                      <Download className="w-3.5 h-3.5 mr-2" /> Unduh Template
                    </Button>
                  </div>
                )}

                {/* Actions Mobile */}
                <div className="grid grid-cols-2 gap-2 pt-2 border-t border-slate-100 dark:border-slate-800">
                  {isUploaded ? (
                    <>
                      {/* Lihat Berkas */}
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full text-blue-600 bg-blue-50 hover:bg-blue-100 border-transparent dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/40"
                        onClick={() => {
                          setShowPdf(true);
                          setSelectedRow(row);
                          setSelectedBerkas(berkasSiswa);
                        }}
                      >
                        <Eye className="w-4 h-4 mr-2" /> Lihat
                      </Button>

                      {/* Ganti / Hapus Berkas */}
                      {!isValidPermanen ? (
                        <div className="flex gap-2 w-full">
                          <Button
                            variant="outline"
                            size="sm"
                            className="w-full px-0"
                            onClick={() => {
                              setShowUpload(true);
                              setSelectedRow(row);
                              setSelectedBerkas(berkasSiswa || null);
                            }}
                          >
                            <Upload className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="destructive"
                            size="sm"
                            className="w-full px-0"
                            onClick={() => {
                              setShowDelete(true);
                              setSelectedRow(row);
                              setSelectedBerkas(berkasSiswa);
                            }}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      ) : (
                        <div className="w-full"></div>
                      )}
                    </>
                  ) : (
                    /* Tombol Upload Full Width jika belum upload */
                    <Button
                      size="sm"
                      className="w-full col-span-2"
                      disabled={isValidPermanen}
                      onClick={() => {
                        if (!isValidPermanen) {
                          setShowUpload(true);
                          setSelectedRow(row);
                          setSelectedBerkas(null);
                        }
                      }}
                    >
                      <Upload className="w-4 h-4 mr-2" /> Upload Berkas
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        // --- DESKTOP TABLE VIEW (Kode Lama Anda) ---
        <div className="grid grid-cols-1 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
          <div className="overflow-x-auto w-full">
            <table className="w-full text-sm text-left">
              <thead className="text-xs text-slate-500 uppercase bg-slate-50 dark:bg-slate-950 dark:text-slate-400 border-b border-slate-200 dark:border-slate-800">
                <tr>
                  <th className="px-4 py-3 w-10 text-center">#</th>
                  <th className="px-4 py-3 min-w-[200px]">Jenis Dokumen</th>
                  <th className="px-4 py-3 min-w-[150px]">Keterangan</th>
                  <th className="px-4 py-3 w-32 text-center">Contoh</th>
                  <th className="px-4 py-3 w-40 text-center">Aksi</th>
                  <th className="px-4 py-3 w-32 text-center">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                {filteredlistBerkas?.map((row: SysBerkas, index: number) => {
                  const berkasSiswa: DataBerkas | undefined =
                    data?.listDataBerkasSiswa.find(
                      (berkas: DataBerkas) =>
                        berkas?.id_sys_berkas == String(row.id_sys_berkas),
                    );
                  const isUploaded = !!berkasSiswa;

                  return (
                    <tr
                      key={row.id_sys_berkas}
                      className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                    >
                      <td className="px-4 py-3 text-center text-slate-400 font-mono text-xs">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3">
                        <div className="font-medium text-slate-900 dark:text-slate-200">
                          {row.jenis_berkas?.nama_jenis_berkas}
                        </div>
                        {row.is_wajib ? (
                          <Badge variant={"destructive"}>Wajib</Badge>
                        ) : (
                          <Badge variant={"outline"}>Opsional</Badge>
                        )}
                      </td>
                      <td className="px-4 py-3 text-slate-500 dark:text-slate-400 text-xs">
                        {row?.keterangan_berkas || "-"}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {row.url_template_berkas ? (
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-7 text-xs border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400"
                                  onClick={() =>
                                    window.open(
                                      `${row.url_template_berkas}?id_sys_periode=${sessionPeriode?.id_sys_periode}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <Download className="w-3 h-3 mr-1.5" /> Unduh
                                </Button>
                              </TooltipTrigger>
                              <TooltipContent>
                                Unduh template dokumen
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        ) : (
                          <span className="text-slate-300 text-xs">-</span>
                        )}
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-center justify-center gap-2">
                          {isUploaded && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    className="h-8 w-8 bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400"
                                    onClick={() => {
                                      setShowPdf(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa);
                                    }}
                                  >
                                    <Eye className="w-4 h-4" />
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>Lihat Berkas</TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}
                          {!isValidPermanen && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    size={isUploaded ? "icon" : "sm"}
                                    className={`h-8 ${
                                      isUploaded
                                        ? "w-8 bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300"
                                        : "px-3 bg-blue-600 hover:bg-blue-700 text-white text-xs"
                                    }`}
                                    onClick={() => {
                                      setShowUpload(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa || null);
                                    }}
                                  >
                                    <Upload className="w-4 h-4" />
                                    {!isUploaded && (
                                      <span className="ml-1.5">Upload</span>
                                    )}
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                  {isUploaded
                                    ? "Ganti Berkas"
                                    : "Upload Berkas"}
                                </TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}
                          {!isValidPermanen && isUploaded && (
                            <TooltipProvider>
                              <Tooltip>
                                <TooltipTrigger asChild>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    className="h-8 w-8 text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
                                    onClick={() => {
                                      setShowDelete(true);
                                      setSelectedRow(row);
                                      setSelectedBerkas(berkasSiswa);
                                    }}
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </Button>
                                </TooltipTrigger>
                                <TooltipContent>Hapus Berkas</TooltipContent>
                              </Tooltip>
                            </TooltipProvider>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-center">
                        {isUploaded ? (
                          <div className="inline-flex items-center gap-1 text-nowrap px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
                            <CheckCircle2 className="w-3 h-3" />
                            Sudah Diupload
                          </div>
                        ) : (
                          <div className="inline-flex items-center gap-1 text-nowrap px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400 border border-slate-200 dark:border-slate-700">
                            Belum Diupload
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* --- MODALS --- */}
      <Modal
        show={showUpload}
        onClose={() => setShowUpload(false)}
        className="md:w-[30rem]"
      >
        <Form
          method="POST"
          selectedRow={selectedRow}
          selectedBerkas={selectedBerkas}
          closeModal={() => setShowUpload(false)}
          idDataPendaftaran={idDataPendaftaran}
        />
      </Modal>

      <Modal show={showDelete} onClose={() => setShowDelete(false)}>
        <Form
          method="DELETE"
          selectedBerkas={selectedBerkas}
          selectedRow={selectedRow}
          closeModal={() => setShowDelete(false)}
        />
      </Modal>

      <Modal
        show={showPdf}
        onClose={() => {
          setShowPdf(false);
          setTimeout(() => setSelectedBerkas(null), 300);
        }}
        className="lg:w-[60vw] w-[95vw]"
      >
        <div className="flex flex-col gap-4 p-2">
          <div>
            <h1 className="font-bold text-lg text-slate-900 dark:text-white">
              {selectedBerkas?.sys_berkas?.jenis_berkas?.nama_jenis_berkas}
            </h1>
            {selectedBerkas?.nomor && (
              <Badge className="mt-2 bg-blue-100 text-blue-700 hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-300">
                Nomor: {selectedBerkas?.nomor}
              </Badge>
            )}
          </div>
          {showPdf && selectedBerkas?.path_berkas && (
            <PdfViewer url={selectedBerkas.path_berkas} />
          )}
        </div>
      </Modal>
    </div>
  );
}
